export const DIGITAL_SETS_LOAD = 'DIGITAL_SETS_LOAD';
export const DIGITAL_SETS_LOAD_SUCCESS = 'DIGITAL_SETS_LOAD_SUCCESS';
export const DIGITAL_SETS_LOAD_ERROR = 'DIGITAL_SETS_LOAD_ERROR';
export const DIGITAL_SETS_ADD = 'DIGITAL_SETS_ADD';
export const DIGITAL_SETS_ADD_SUCCESS = 'DIGITAL_SETS_ADD_SUCCESS';
export const DIGITAL_SETS_ADD_ERROR = 'DIGITAL_SETS_ADD_ERROR';
export const DIGITAL_SETS_UPDATE = 'DIGITAL_SETS_UPDATE';
export const DIGITAL_SETS_UPDATE_SUCCESS = 'DIGITAL_SETS_UPDATE_SUCCESS';
export const DIGITAL_SETS_UPDATE_ERROR = 'DIGITAL_SETS_UPDATE_ERROR';
export const DIGITAL_SETS_DELETE = 'DIGITAL_SETS_DELETE';
export const DIGITAL_SETS_DELETE_SUCCESS = 'DIGITAL_SETS_DELETE_SUCCESS';
export const DIGITAL_SETS_DELETE_ERROR = 'DIGITAL_SETS_DELETE_ERROR';
